import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { IconLayersThree01, IconPlus } from "@pentabd/icons";
import { Button, Header } from "@pentabd/ui";

import { useUser } from "@hooks/useUser";

import { getAccess } from "@helpers/permissionController";

import { ROUTES } from "@constants/routes";

const {
  CREATE,
  HRM: { POSITIONS },
} = ROUTES;

export const PositionsPageHeader = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { user } = useUser();
  const { realm_roles: roles } = user || {};

  const breadcrumbs = [
    {
      icon: <IconLayersThree01 fill="dark" size="20" />,
    },
    {
      label: t("POSITION_LIST.BREADCRUMBS.FIRST_STEP"),
      link: POSITIONS,
    },
    {
      label: t("POSITION_LIST.BREADCRUMBS.SECOND_STEP"),
    },
  ];

  const actions = [
    <Button
      fill="outline"
      size="sm"
      type="light"
      htmlType="button"
      onClick={() => navigate(CREATE)}
    >
      <IconPlus size="20" /> {t("POSITION_LIST.ADD_BUTTON")}
    </Button>,
  ];

  const headerText = {
    header: t("POSITION_LIST.LABEL"),
    subHeader: t("POSITION_LIST.DESCRIPTION"),
  };

  return (
    <Header
      breadcrumbs={breadcrumbs}
      headerText={headerText}
      actions={getAccess(roles, "POSITION_MODIFY_PAGE") ? actions : <></>}
    />
  );
};
